import { render, staticRenderFns } from "./StarJoinItem.vue?vue&type=template&id=6be448a0"
import script from "./StarJoinItem.vue?vue&type=script&lang=js"
export * from "./StarJoinItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports